// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomButtonBox_wrapper__FVjDO","left":"BottomButtonBox_left__cVwZE","right":"BottomButtonBox_right__VIfQ8"};